// extracted by mini-css-extract-plugin
module.exports = {"flex":"Search_flex__3MrwQ","searchIcon":"Search_searchIcon__1zxPF"};